import Accordion from "components/Accordion";
import AccordionElement from "components/Accordion/element";
import React, { useEffect, useMemo, useState } from "react";
import { guidance } from "widgets/Onboarding/config/guidance";
import useAuth from "widgets/Onboarding/hooks/useAuth";
import { IconUILightbulb } from "components/Icon/UI";
import "./style.scss";
import PropTypes from "prop-types";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";

const Guidance = ({ isOpen, handleClose, currentStep }) => {
  const currentFields = currentStep ? currentStep[0]?.required_fields : " ";
  const { user } = useAuth();
  const [helpFields, setHelpFields] = useState([]);
  const [hideGuide, setHideGuide] = useState(false);
  const { translate: t } = useLanguageProvider();

  useMemo(() => {
    const fieldsArray = [];
    Object.keys(guidance).forEach((field) => {
      if (currentFields?.includes(field)) {
        if (user) {
          if (!Object.keys(user).includes(field)) {
            fieldsArray.push(guidance[field]);
          }
        } else {
          fieldsArray.push(guidance[field]);
        }
      }
    });
    setHelpFields(fieldsArray);
  }, [currentFields, user]);

  useEffect(() => {
    setHideGuide(helpFields?.length === 0);
  }, [helpFields]);

  return (
    <div
      className={`guidance ${isOpen ? "open" : "close"} ${
        hideGuide ? "hide" : ""
      }`}
    >
      <button type="button" id="close" onClick={handleClose} />

      <div className="content">
        <span className="help-icon --small"><IconUILightbulb fillRule="evenodd" viewBox="0 0 100 100" /></span>
        <Accordion>
          {helpFields.map((field, i) => (
            <AccordionElement
              id={`guidance_${i}`}
              key={`guidance_${i}`}
              title_text={t(field.title)}
              open={i === 0}
            >
              <div className="point" key={`tip-${i}`}>
                <div
                  dangerouslySetInnerHTML={{ __html: t(field.content) }}
                  className="copy"
                />
              </div>
            </AccordionElement>
          ))}
        </Accordion>
        <div className="actions">
          <a
            href="http://docs.chuffed.org/"
            className="link-button --secondary-outline --bold"
          >
            {t("Ask Support")}
          </a>
        </div>
      </div>
    </div>
  );
};

Guidance.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  currentStep: PropTypes.arrayOf(PropTypes.shape({ required_fields: PropTypes.array.isRequired })),
};

export default Guidance;
